export type ZoomWebinar = {
  agenda: string | null
  duration: number
  id: number
  isRecurring: boolean
  joinUrl: string
  occurrences: ZoomWebinarOccurrence[] | null
  recurrence: ZoomWebinarRecurrence | null
  startTime: string
  topic: string
}

export type ZoomRegistrantCreatedResponse = {
  id: number,
  join_url: string
  registrant_id: string
  start_time: Date
  topic: string
}

export type ZoomRegistrationSuccess = {
  registrant: NewZoomWebinarRegistrant
  response: ZoomRegistrantCreatedResponse
}

export type NewZoomWebinarRegistrant = {
  companyName?: string,
  companySize?: ZoomRegistrantCompanySize | null,
  email: string
  firstName: string
  lastName: string
}

export type ZoomWebinarOccurrence = {
  duration: number
  id: string
  startTime: string
  status: string
}

export type ZoomWebinarRecurrence = {
  endDateTime: string
  monthlyDay?: number
  monthlyWeek?: number
  monthlyWeekDay?: number
  repeatInterval: number
  type: ZoomWebinarRecurrenceType
  weeklyDays?: string
}

export enum ZoomWebinarRecurrenceType {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly'
}

export type ZoomRegistrantCompanySize =
  | '1-50'
  | '50-500'
  | '500+'
